import { getApiCall, postApiCall } from "../../utils/request";
import { returnErrors } from "../errorAction";
import { GET_COMPANY_DETAILS, EDIT_COMPANY, APPLY_THEME, GET_COMPANY_COLORS, GET_COMPANY_PLANS, SHOW_WARNING, HIDE_WARNING } from '../../actionType/type';

export const getCompanyDetail = () => async (dispatch) => {
    try {
        const response = await getApiCall(`company/details`);
        dispatch({ type: GET_COMPANY_DETAILS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const savedCompany = (obj) => async (dispatch) => {
    var data = new FormData()
    data.append("name", obj.name);
    obj.image !== undefined && data.append("image", obj.image);
    data.append('website', obj.website);
    data.append("unlock_skills", obj.unlock_skills);
    data.append("proctored_test", obj.proctored_test);
    try {
        const response = await postApiCall(`admin/company/details`, data);
        if (response.data.success) {
            dispatch({ type: EDIT_COMPANY, payload: response.data.data });
        }
        else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }

    } catch (error) {
        returnErrors(dispatch, error?.response?.data?.message, error?.response?.status);
    }
}

export const applyTheme = (theme) => async (dispatch) => {
    try {
        const response = await postApiCall(`admin/company/colors`, theme);
        if (response.data.success) {
            dispatch({ type: APPLY_THEME, payload: theme })
            returnErrors(dispatch, 'Colors updated', response?.status);
        } else {
            returnErrors(dispatch, response?.data?.message, response?.status);
        }
    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }

}

export const gerColorCodes = () => async (dispatch) => {
    try {
        const response = await getApiCall(`company/colors`);
        dispatch({ type: GET_COMPANY_COLORS, payload: response.data.colors });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const getPlans = () => async (dispatch) => {
    try {
        const response = await getApiCall(`company/plan`);
        dispatch({ type: GET_COMPANY_PLANS, payload: response.data.data });

    } catch (error) {
        returnErrors(dispatch, error.response?.data.message, error.response?.status)
    }
}

export const showWarning = () => async (dispatch) => {
    return dispatch({ type: SHOW_WARNING })
}

export const closeSubModal = () => async (dispatch) => {
    return dispatch({ type: HIDE_WARNING })
}